var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PlayMenu',{ref:"playlist",attrs:{"url":_vm.pathToList}})
}
var staticRenderFns = []

export { render, staticRenderFns }